import dayjs from "dayjs";

export const TIMEZONE_OPTIONS = [
  { value: "PST", label: "PST" },
  { value: "EST", label: "EST" },
  { value: "CST", label: "CST" },
  { value: "MST", label: "MST" },
];

export const parseTimeToDayjs = (timeStr) => {
  if (!timeStr) return null;
  return dayjs(`1970-01-01 ${timeStr}`);
};

export const buildInitialRestartForm = (c) => {
  if (!c) return null;
  const tz = c.startTimezone || c.endTimezone || "PST";
  return {
    coverageStartDate: c.coverageStartDate ? dayjs(c.coverageStartDate) : null,
    campaignStartDate: c.campaignStartDate ? dayjs(c.campaignStartDate) : null,
    campaignStartTime: parseTimeToDayjs(c.campaignStartTime),
    campaignEndDate: c.campaignEndDate ? dayjs(c.campaignEndDate) : null,
    campaignEndTime: parseTimeToDayjs(c.campaignEndTime),
    campaignTimeZone: tz,
    blackoutDates: [...(c.blackoutDates || [])],
  };
};

export const buildOutreachWindowsForRestart = (campaignData) =>
  (campaignData?.outreachWindows || []).map((w) => ({
    startTime: w.startTime,
    endTime: w.endTime,
    timezone: w.timezone,
    isCustom: !!w.isCustom,
    isActive: w.isActive !== false,
  }));

/**
 * Builds POST body for admin/campaign/update (restart flow).
 */
export const buildRestartCampaignUpdatePayload = ({
  campaignData,
  restartForm,
  campaignId,
  refBrandId,
}) => {
  if (!campaignData || !restartForm) return null;
  const rf = restartForm;
  const start = rf.campaignStartDate.startOf("day");
  const end = rf.campaignEndDate.startOf("day");
  const filteredBlackouts = (rf.blackoutDates || []).filter((dateStr) => {
    const d = dayjs(dateStr).startOf("day");
    return (
      (d.isAfter(start) || d.isSame(start)) &&
      (d.isBefore(end) || d.isSame(end))
    );
  });

  const payload = {
	  id: campaignId,
	  refBrandId: refBrandId,
    coverageStartDate: dayjs(rf.coverageStartDate).format("YYYY-MM-DD"),
    campaignStartDate: dayjs(rf.campaignStartDate).format("YYYY-MM-DD"),
    campaignStartTime: dayjs(rf.campaignStartTime).format("HH:mm:ss"),
    startTimezone: rf.campaignTimeZone,
    campaignEndDate: dayjs(rf.campaignEndDate).format("YYYY-MM-DD"),
    campaignEndTime: dayjs(rf.campaignEndTime).format("HH:mm:ss"),
    endTimezone: rf.campaignTimeZone,
	  blackoutDates: filteredBlackouts,
	  status: "RESTART",
	  outreachWindows: buildOutreachWindowsForRestart(campaignData),
  };
  return payload;
};
